import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import React from 'react';
import CollapsibleCallsList from './CollapsibleCallsList';

const name = "CallsPanel";

const CallsPanel: React.FC = () => {
    return (
        <Paper elevation={4}>
            < Box id="left-panel" sx={{ width: 260, p: 1 }}>
                <CollapsibleCallsList />
            </Box >
        </Paper>
    )
}

CallsPanel.displayName = name;

export default React.memo(CallsPanel);